import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'angular-2-local-storage';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
    constructor(private localStorage: LocalStorageService) {

    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = `Bearer ${this.localStorage.get('token')}`;
        const clonedRequest = req.clone({ headers: req.headers.set('Authorization', token) });
        return next.handle(clonedRequest);
    }
}
